import React from "react";
import {List, ListItem} from "@mui/material";
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {Link} from 'react-router-dom';
import {connect} from "react-redux";
import {actions as opportunityActions, selectors as opportunitySelectors} from "../../Ducks/opportunity";
import {bindActionCreators} from "redux";
import {OpportunityDirtyConfirmationPopup} from "../Containers/Opportunity/OpportunityDetails";

const theme = createTheme({});

const MyMenu = (props) => {
    const {item, user, isOpportunityDirty, setIsOpportunityDirty} = props;
    const capabilities = user.user_details.capabilities.map((item) => item.capability_title);
    const role = user.user_details.role_title;

    const hasCapability = (menuItem) => menuItem.capabilities === undefined || menuItem.capabilities.some((r) => capabilities.includes(r));
    const hasRole = (menuItem) => menuItem.role === undefined || menuItem.role.includes(role);
    const canView = (menuItem) => hasCapability(menuItem) && hasRole(menuItem);

    const handleClick = (event) => {
        const {href} = event.target;

        if (isOpportunityDirty) {
            event.preventDefault();
            OpportunityDirtyConfirmationPopup().then((result) => {
                if (result.isConfirmed) {
                    window.location.href = href; // Manually navigate
                    setIsOpportunityDirty(false);
                }
            })
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <div className={item.items ? 'menu-item menu-item-has-children' : 'menu-item'}
                 style={{marginLeft: '8px', marginRight: '8px'}}>
                {
                    item.items && canView(item) ?
                        <>
                            <Link
                                style={{textDecoration: 'none', color: 'white'}}
                                to={{
                                    pathname: item.to
                                }
                                }
                                onClick={handleClick}
                            >
                                {item.title}
                            </Link>
                            <List className="sub-menu">
                                {
                                    item.items.filter((i) => canView(i)).map((i, index) =>
                                        <ListItem key={index}>
                                            <Link
                                                style={{
                                                    textDecoration: 'none',
                                                    fontSize: '14px',
                                                    color: "#000"
                                                }}
                                                to={{
                                                    pathname: i.to
                                                }
                                                }
                                                onClick={handleClick}
                                            >
                                                {i.title}
                                            </Link>
                                        </ListItem>)
                                }
                            </List>
                        </>
                        : canView(item) && (
                        <Link
                            style={{textDecoration: 'none', color: 'white'}}
                            to={{
                                pathname: item.to
                            }
                            }
                            onClick={handleClick}
                        >
                            {item.title}
                        </Link>
                    )
                }
            </div>

        </ThemeProvider>
    );
};

const mapStateToProps = (state) => ({
    isOpportunityDirty: opportunitySelectors.isOpportunityDirty(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        setIsOpportunityDirty: opportunityActions.setIsOpportunityDirty,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MyMenu);
